import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "aa_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (accepted) => {
    localStorage.setItem(KEY, JSON.stringify({ accepted, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:left-6 md:bottom-6 z-50" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl bg-white border border-[#EAEAEA] rounded-2xl shadow-lg p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-[#E5EEFF] text-[#0055FF] flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1 text-sm text-[#333] leading-relaxed">
          <p>
            Usiamo cookie tecnici essenziali per il funzionamento del sito (sessione di accesso) e, con il tuo consenso,
            un cookie per memorizzare la tua preferenza. Non usiamo cookie di profilazione di terze parti. Leggi la{" "}
            <Link to="/privacy" className="text-[#0055FF] underline" data-testid="cookie-privacy-link">
              Informativa Privacy
            </Link>{" "}
            e la <Link to="/cookies" className="text-[#0055FF] underline" data-testid="cookie-policy-link">Cookie Policy</Link>.
          </p>
        </div>
        <div className="flex gap-2 shrink-0 self-stretch md:self-auto">
          <button
            onClick={() => decide(false)}
            className="h-10 px-4 rounded-full border border-[#EAEAEA] text-sm font-medium hover:border-[#111]"
            data-testid="cookie-reject"
          >
            Rifiuta
          </button>
          <button
            onClick={() => decide(true)}
            className="h-10 px-5 rounded-full bg-[#111] text-white text-sm font-medium hover:bg-[#333]"
            data-testid="cookie-accept"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
